<template>
  <base-widget
    :style="heightStyles"
    scrollable
    :condensed="!responsive.lg"
  >
    <avatar-editor
      ref="editor"
      :initial-step="image ? 1 : 0"
      :pre-filled-image="image"
      @close-editor="onEditorClosed"
      @change-avatar="changeAvatar"
      @delete-avatar="deleteAvatar"
    />
    <!-- Main data -->
    <base-avatar
      :readonly="readonly"
      class="mx-auto mb-3"
      :username="`${ client.first_name } ${ client.last_name }`"
      :img="image ? image : client.first_name? null : '/img/person.png'"
      @click="loadImage"
    />
    <template v-if="intitutionProfile().includes('burberry') || institutionName">
      <name-editor
        v-if="client.first_name || client.last_name"
        v-model="client"
        :readonly="readonly"
        @input="update(['first_name', 'last_name'])"
      />
    </template>
    <template
      v-else
    >
      <name-editor
        v-model="client"
        :readonly="readonly"
        @input="updateName"
      />
    </template>
    <template v-if="!editEmail && !!client.external_id">
      <base-text
        trim
        class="email pb-1 w-100"
        style="cursor: default;"
      >
        ID {{ client.burberry_id || client.external_id }}
      </base-text>
    </template>

    <div v-if="isAdminMode" style="margin-top: 20px;">
      <slot />
    </div>
    <!-- Information -->
    <!-- <base-input-text
      v-model="client.email"
      class="client__info"
      label="Email"
      placeholder="Add Email"
      :readonly="readonly"
      @input="update(['email'])"
    /> -->
    <div class="mt-4">
      <base-text
        size="m"
        semibold
        class="title-email"
      >
        Email
      </base-text>
      <template v-if="!editEmail">
        <base-text
          trim
          class="email pb-1"
          style="text-align: unset; color: #000; margin-left: 0; cursor: pointer;"
          @click="onStartEditEmail"
        >
          {{ client.email }}
        </base-text>
      </template>

      <div
        v-else
        class="email email__editing d-flex"
        :class="{'email__is-invalid': !!emailError}"
        style="text-align: unset; margin-left: 0;"
      >
        <validation-provider
          ref="email_form"
          rules="email"
          mode="passive"
          name="email"
        >
          <base-text-editable
            ref="emailInput"
            v-model="client.email"
            placeholder="example@example.com"
            style="text-align: unset; margin-left: 0;"
            :error="!!emailError"
            class="email"
            :class="!!emailError ? 'email--invalid' : 'email--active'"
            @complete="blurEmail()"
            @blur="blurEmail()"
          />
        </validation-provider>
        <base-icon
          v-if="!!emailError"
          icon="information-error"
        />
        <div style="display: flex; align-items: center;">
          <base-icon
            style="margin-left: 12px; cursor: pointer;"
            :icon="`${!!emailError? 'check-grey' : 'check-black'}`"
          />
        </div>
      </div>
    </div>
    <!-- batas -->
    <base-input-text
      v-model="client.phone_number"
      class="client__info"
      label="Phone"
      maxlength="20"
      placeholder="Add Phone"
      :readonly="readonly || !isAllowEditPhoneNumber"
      :value="(client.phone_number)? client.phone_number: '-'"
      @keypress.native="phoneNumberFormat($event)"
      @input="update(['phone_number'])"
    />

    <template>
      <base-input-text
        readonly
        style="margin-top:7%"
        label="PREFERENCES"
      />
      <base-text
        trim
        class="preference"
        @click="onStartEditEmail"
      >
        <div class="mb-2" style="display:flex">
          <base-icon
            :icon="client.email_unsubscribe ? 'xcross-bold' : 'check-bold'"
          />
          <base-text class="preferense-text ml-1">
            Email
          </base-text>
          <base-text
            class="preferense-opt ml-1"
            :style="`${ client.email_unsubscribe ? 'color: #E7873C' : 'color: #2E7D32'}`"
          >
            {{ client.email_unsubscribe ? 'Opted-out' : 'Opted-in' }}
          </base-text>
        </div>
        <div class="mt-2" style="display:flex">
          <base-icon
            :icon="client.message_unsubscribe ? 'xcross-bold' : 'check-bold'"
          />
          <base-text
            class="preferense-text ml-1"
          >
            Messaging
          </base-text>
          <base-text
            class="preferense-opt ml-1"
            :style="`${client.message_unsubscribe ? 'color: #E7873C' : 'color: #2E7D32'}`"
          >
            {{ client.message_unsubscribe ? 'Opted-out' : 'Opted-in' }}
          </base-text>
        </div>
      </base-text>
    </template>

    <base-input-text
      v-model="client.location"
      class="client__info"
      label="Based"
      maxlength="50"
      placeholder="Add location"
      :readonly="readonly || !isAllowEditLocation"
      :value="(client.location)? client.location: '-'"
      @input="update(['location'])"
    />

    <validation-provider
      ref="date_form"
      rules="date|past_date"
      mode="passive"
      name="birth date"
    >
      <date-editor
        class="client__info"
        :value="(client.birth_date)? $options.filters.nicedate(client.birth_date): '-'"
        :readonly="readonly || !isAllowEditBirthday"
        @input="updateBirthDate"
      />
    </validation-provider>

    <!-- Last Active -->
    <base-input-text
      v-if="!institutionName"
      class="client__info"
      :value="(client.last_active)? $options.filters.nicedate(client.last_active): '-'"
      label="Last Active"
      placeholder="-"
      readonly
    />

    <!-- Groups -->
    <div class="client__info">
      <div class="client__info__label">
        Groups
      </div>
      <div v-if="!customerGroups">
        -
      </div>
      <div
        v-for="(group, index) in customerGroups"
        :key="group.url"
        class="group__item"
      >
        <base-text
          class="group__name"
          semibold
        >
          <!-- NOTE: truncated at 40 chars because that number matches figma -->
          {{ group.name | truncate(40) }} ({{ group.member_count }})
        </base-text>
        <base-icon
          v-if="!group.is_supergroup || !group.via_integration"
          icon="x-circle"
          @click="deleteGroup(group, index)"
        />
      </div>
    </div>
  </base-widget>
</template>

<script>

import { EventBus } from '@/event-bus';
import BaseTextEditable from '@/components/Base/BaseTexteditable';
import BaseIcon from '@/components/Base/BaseIcon';
import { ValidationProvider } from 'vee-validate';
import responsive from '@/components/mixins/responsive';
import minHeightMixin from '../mixins/minheight';
import NameEditor from './ClientInformation/NameEditor';

export default {
  name: 'ClientInformation',
  components: {
    NameEditor,
    BaseIcon,
    ValidationProvider,
    BaseTextEditable,
  },
  mixins: [
    minHeightMixin,
    responsive,
  ],
  props: {
    /**
     * UI Flag related to add_customers
     */
    addCustomersFlag: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    showUnassign: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hasPermission: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      client: {},
      nameFL: {},
      image: '',
      showEditor: false,
      editEmail: false,
      previousEmail: '',
      emailError: false,
      institution: '',
    };
  },
  computed: {
    customerGroups() {
      if (!this.client?.member_of?.length) return [];
      return this.client.member_of.filter((group) => !group.is_supergroup && !group.via_integration);
    },
    unsubscribed() {
      if (this.value) {
        return this.value.unsubscribed;
      }
      return false;
    },
    selectedItem() {
      if (this.unsubscribed) {
        return {
          name: 'Unsubscribed',
          value: this.unsubscribed,
          color: '#E9AD7D',
        };
      }
      return {
        name: 'Subscribed',
        value: !this.unsubscribed,
        color: null,
      };
    },
    items() {
      return [
        {
          name: 'Subscribed',
          value: false,
          color: null,
        },
        {
          name: 'Unsubscribed',
          value: true,
          color: '#E9AD7D',
        },
      ];
    },
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
    isPermissionUnassign() {
      return this.usePermission('assign_and_unassign_client_privilege');
    },
    isAllowEditPhoneNumber() {
      return this.usePermission('allow_edit_phone_number');
    },
    isAllowEditLocation() {
      return this.usePermission('allow_edit_location');
    },
    isAllowEditBirthday() {
      return this.usePermission('allow_edit_birthday');
    },
    institutionName() {
      if (this.$store.state.account.user.profile.institution.name.toLowerCase().includes('burberry')) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        this.client = { ...val };
        this.nameFL = { ...val };
        this.image = val.profile_pic;
        this.localEmail = val.email;
      },
      immediate: true,
      deep: true,
    },
    'client.email': {
      handler(value) {
        if (!this.editEmail) {
          this.previousEmail = value;
        }
      },
      immediate: true,
    },
    'client.image': {
      handler(value) {
        this.image = value;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.hasPermission = this.usePermission('delete_client_privilege');
  },
  methods: {
    intitutionProfile() {
      return this.$store.state.account.user.profile.institution.name;
    },
    onEditorClosed() {
      this.showEditor = false;
    },
    changeAvatar({ file, image }) {
      this.$emit('change-avatar', file);
      this.image = image;
    },
    deleteAvatar() {
      this.image = null;
      this.$emit('delete-avatar');
    },
    phoneNumberFormat(evt) {
      const allowedChars = [32, 40, 41, 43, 45, 46];
      const charCode = (evt.which) ? evt.which : evt.keyCode;

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && !allowedChars.includes(charCode)) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    update(keys) {
      const data = {
        pk: this.client.pk,
      };

      keys.forEach((key) => {
        data[key] = this.client[key];
      });

      this.$emit('input', data);
    },
    updateName(evt) {
      const firstName = this.nameFL.first_name;
      const lastName = this.nameFL.last_name;
      this.$refs.date_form.validate(evt).then((result) => {
        if (evt.first_name && evt.last_name) {
          this.update(['first_name', 'last_name']);
        } else {
          EventBus.$emit('toast-error', "Name can't be empty");
          this.client.first_name = firstName;
          this.client.last_name = lastName;
        }
      });
    },
    updateBirthDate(evt) {
      const birthDate = this.client.birth_date;
      this.$refs.date_form.validate(evt).then((result) => {
        if (result.valid) {
          const date = this.$moment(`${evt.month}/${evt.day}/${evt.year}`, 'MM/DD/YYYY');
          this.client.birth_date = date.format();
          this.update(['birth_date']);
        } else {
          this.client.birth_date = birthDate;
        }
      });
    },
    deleteGroup(group, index) {
      EventBus.$emit('confirm', {
        title: 'Remove client from group?',
        message: `You are about to remove 
        ${this.client.first_name} ${this.client.last_name}
        from your ${group.name} group.`,
        callback: (confirm) => {
          if (confirm) {
            this.$emit('delete-group', group);
            this.client.member_of.splice(index, 1);
          }
        },
        positiveText: 'Remove',
      });
    },
    // Image methods
    loadImage() {
      this.showEditor = true;
      this.$nextTick().then(() => {
        this.$refs.editor.open();
      });
    },
    updateEmail() {
      const { email } = this.client;
      const currentEmail = this.previousEmail;

      this.$refs.email_form.validate(email).then((result) => {
        console.log(result);
        if (result.valid) {
          this.editEmail = false;
          this.emailError = false;
          this.update(['email']);
          EventBus.$on('statusSuccess', (status) => {
            if (status === 200) {
              this.previousEmail = this.client.email;
            }
          });
          EventBus.$on('toast-error', () => {
            this.client.email = currentEmail;
          });
        } else {
          // without setTimeout focusing doesn't work when trying to update via blur
          setTimeout(() => this.$refs.emailInput.$el.focus(), 200);
          this.emailError = this.client.email;
        }
      });
    },
    onStartEditEmail() {
      if (this.readonly) return;
      this.editEmail = true;
      this.$nextTick(() => {
        this.$refs.emailInput.$el.focus();
      });
    },
    blurEmail() {
      if (this.emailError === this.client.email) {
        this.emailError = false;
        this.editEmail = false;
        this.client.email = this.previousEmail;
      } else {
        this.updateEmail();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.email{
  font-family: $font-family-sans-serif-light;
  font-size: 0.875rem;
  line-height: 1.5;
  color: $black;
  margin: 4px auto;
  text-align: center;
  min-height: 20px;
  max-width: 205px;
  @media (max-width: 1023px) {
    max-width: 157px;
  }

  &__editing {
    // border: 2px solid #D1B0A0;
    border: 2px solid #C6C6C6;
    margin-left: 0;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    align-content: center;
    flex-wrap: nowrap;
  }

  &__is-invalid {
    border: unset;
    margin: 4px auto !important;
    margin-left: unset !important;
    border-radius: 3px;
    box-shadow: inset 0 0 0 1px #DA1E28;
    box-sizing: border-box;
    & span{
      height: 35px;
    }
  }
  &--invalid{
    line-height: 1.8 !important;
    @media (min-width: 1024px) {
    width: 186px;
    }
    @media (max-width: 1023px) {
    max-width: 137px;
    }
  }

  &--active{
    @media (min-width: 1024px) {
    width: 200px;
    }
    @media (max-width: 1023px) {
    max-width: 151px;
    }
  }
}
.group{
  &__name {
    line-height: 16px;
    font-weight: 300;
    font-size: 14px;
    font-family: 'SilkaLight' !important;
    color: #1B1B1B;
  }
  &__item{
    padding: 17px 10px !important;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #D4D4D4;
    border-radius: 5px;
    padding: 1rem;
    margin-top: 8px;
  }
}
.client__info{
    margin-top: 10px;

    &__label{
        font-family: 'SilkaLight';
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        text-transform: uppercase;
        color: #767676;
    }
}
.clickable {
  cursor: pointer;
}
.preference{
  margin-top: -10%;
  font-family: "SilkaLight", "Helvetica Neue", Arial, sans-serif;
  font-size: 0.875rem;
  line-height: 1;
  color: #646464;
  min-height: 45px;
}
.preferense-text{
  font-family: "SilkaSemibold", "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color:#333333
}
.preferense-opt{
  font-family: "SilkaSemibold", "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
}
.title-email{
font-family: 'SilkaLight';
font-style: normal;
font-weight: 300;
font-size: 12px;
line-height: 100%;
letter-spacing: 0.01em;
text-transform: uppercase;
color: #767676;
margin-bottom: 10px;
}
::v-deep .base-input-text{
  &__label {
    font-family: 'SilkaLight';
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: #767676 !important;
    display: flex;
    align-items: center;
  }
  &__value{
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  text-decoration-line: underline;
  color: #1B1B1B;
  }
}

::v-deep .profile-selector{
  &__label{
    font-family: 'SilkaLight';
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: #767676;
  }
}
</style>
